import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_USUARIOS

export default class AreasService {
  paginate () {
    return http.get(`${baseUrl}/areas/listar-areas`, {
      headers: {
        loading: true
      }
    })
  }
}
